var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_container container_history",attrs:{"id":"trade-history-screen"}},[_c('div',{staticClass:"box-title title-medium-small"},[_vm._v(_vm._s(_vm.$t('menu.trade_history')))]),_c('div',{staticClass:"trade-history-content"},[_c('trade-history',{staticClass:"order-group-screen",attrs:{"options":{isNoPadding: true}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }